import { noop } from 'lodash'
import { createContext } from 'react'

export const FormStateContext = createContext([{}, noop])
